module.exports = __webpack_public_path__ + "static/img/scene-hstjs.7ce9551.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scene/scene-hstjs.png
// module id = J3K1
// module chunks = 1